import { Box, Button, Menu, MenuItem, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ChevronDown, ExternalLink, SdxColors, SecondaryColors, filterSdxIconToWhite } from "@sodexo/ui-components";
import { useState } from "react";
import { Link } from "react-router-dom";
import SdxLogo from "../Logo";

export default function NavBar() {
  const [adminModuleMenuAnchorEl, setAdminModuleMenuAnchorEl] = useState<null | HTMLElement>(null);
  const adminModuleMenuOpen = Boolean(adminModuleMenuAnchorEl);

  const openAdminModuleMenu = (event: React.MouseEvent<HTMLButtonElement>) =>
    setAdminModuleMenuAnchorEl(event.currentTarget);
  const closeAdminModuleMenu = () => setAdminModuleMenuAnchorEl(null);

  const AdminModuleMenuItem = ({ url, label }: { url: string; label: string }) => (
    <MenuItem onClick={closeAdminModuleMenu}>
      <ExternalLink style={{ width: 16, height: 16, marginRight: 4 }} />
      <a href={url} target="_blank" style={{ textDecoration: "none" }}>
        {label}
      </a>
    </MenuItem>
  );

  return (
    <>
      <NavBarComponent>
        <NavLink to="/">
          <Stack direction="row" justifyContent="start" alignItems="baseline">
            <SdxLogo />
            <Box>
              <Typography variant="h6" color="white" className="sansa-semibold" sx={{ marginLeft: "1.5em" }}>
                AI Platform
              </Typography>
            </Box>
          </Stack>
        </NavLink>

        <Stack direction="row" justifyContent="center" alignItems="center">
          <NavButton onClick={openAdminModuleMenu} variant="text">
            Admin module
            <ChevronDown style={{ ...filterSdxIconToWhite, height: 20, width: 20, marginLeft: 4 }} />
          </NavButton>
          <Menu anchorEl={adminModuleMenuAnchorEl} open={adminModuleMenuOpen} onClose={closeAdminModuleMenu}>
            <AdminModuleMenuItem label="IFM dev" url="https://admin-module.azurewebsites.net/" />
            <AdminModuleMenuItem label="SDX dev" url="https://aip.dev.datalab.sodexo.com/adminmodule/" />
            <AdminModuleMenuItem label="SDX uat" url="https://aip.uat.datalab.sodexo.com/adminmodule/" />
            <AdminModuleMenuItem label="SDX prod" url="https://aip.datalab.sodexo.com/adminmodule/" />
          </Menu>
        </Stack>
      </NavBarComponent>
      {process.env.NODE_ENV !== "production" && (
        <WarningDevBanner variant="subtitle2">
          This is a dev environment, documentations are not up to date. Please use{" "}
          <a href="https://aip.datalab.sodexo.com">https://aip.datalab.sodexo.com</a>
        </WarningDevBanner>
      )}
    </>
  );
}

const NavBarComponent = styled("nav")(({ theme }) => ({
  height: theme.variables.topBarHeight,
  background: SdxColors.blueDarker,
  a: {
    color: SdxColors.white,
    textDecoration: "none",
  },
  width: "100%",
  display: "flex",
  flexDirection: "row",
  gap: theme.spacing(5),
  alignItems: "center",
  justifyContent: "space-between",
  padding: `0 ${theme.spacing(3)}`,
}));

const NavLink = styled(Link)({
  textDecoration: "none !important",
});

const NavButton = styled(Button)({
  boxShadow: "none",
  textTransform: "none",
  textDecoration: "none",
  fontSize: 14,
  fontFamily: "Open Sans",
  fontWeight: "normal",
  border: "none",
  lineHeight: 1.5,
  backgroundColor: "transparent",
  color: SdxColors.white,
  padding: "10px 15px",
  "&:hover": {
    fontWeight: "bold",
    color: SdxColors.white,
    textDecoration: "none",
    padding: "10px 15px",
  },
  "&:active": {
    boxShadow: "none",
  },
  "&:focus": {
    boxShadow: "none",
  },
});

const WarningDevBanner = styled(Typography)(({ theme }) => ({
  backgroundColor: SecondaryColors.yellow,
  width: "100%",
  padding: `${theme.spacing(1)} ${theme.spacing(1)}`,
  textAlign: "center",
}));
